export default __webpack_public_path__ + "static/media/NavajoWitch.7b65068a.png";